import React from 'react';

const VideoPlayer = ({ src }) => {
  return (
   <>
    <div class="embed-responsive embed-responsive-16by9" >
    <iframe    width="100%"
      height="300" class="embed-responsive-item" src={`https://keyzi.com.au/keyzi-admin/public${src}`} allowfullscreen></iframe>
    </div>
   </>)
};

export default VideoPlayer;